import { createContext, useContext } from 'react';

import { INotification } from '@ergeon/core-components/exports/FixedNotifications.ts';

interface ImperativeToasts {
  publish(notification: INotification): void;
}

export const ToastsContext = createContext<ImperativeToasts>(null!);

export function useToast() {
  return useContext(ToastsContext);
}
